<!-- MODAL Agregar usuario -->
<div
  style="overflow-y: auto"
  mdbModal
  #agregarUsuario="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form
        [formGroup]="formulario"
        (ngSubmit)="
          ValidaQueExisteDatosUsuario(usuarioSucursalList);
          agregarUsuario.hide()
        "
      >
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="agregarUsuario.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de usuario
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label
                  >Inactivo<input
                    formControlName="activo"
                    type="checkbox"
                    checked
                  /><span class="lever"></span>Activo</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Left -->
            <div class="col">
              <div class="md-form">
                <input
                  formControlName="rut_usuario"
                  value=""
                  type="text"
                  id="arut"
                  class="form-control"
                  placeholder="9.999.999-9"
                  required
                  formatRut
                  #rut_usuario
                  maxLength="13"
                  (blur)="mascaraRut($event)"
                  disabled
                />
                <label for="rut">RUT</label>
                <div
                  *ngIf="
                    formulario.get('rut_usuario').invalid &&
                    (formulario.get('rut_usuario').dirty ||
                      formulario.get('rut_usuario').touched)
                  "
                >
                  <mdb-error
                    *ngIf="
                      formulario.get('rut_usuario').hasError('ValidaFormatoRut')
                    "
                    >Por favor ingrese un RUT Valido</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('rut_usuario').hasError('required')"
                  ></mdb-error>
                  <mdb-error
                    *ngIf="formulario.get('rut_usuario').hasError('maxlength')"
                  ></mdb-error>
                  <mdb-error
                    *ngIf="formulario.get('rut_usuario').hasError('minlength')"
                  ></mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input
                  formControlName="login"
                  value=""
                  type="text"
                  id="ausuario"
                  class="form-control"
                  placeholder="Usuario"
                  [(ngModel)]="UsuarioObject.login"
                  required
                  #usuario
                  maxLength="20"
                />
                <label for="usuario">Usuario</label>
                <div
                  *ngIf="
                    formulario.get('login').invalid &&
                    (formulario.get('login').dirty ||
                      formulario.get('login').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('login').hasError('required')"
                    >El Usuario es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('login').hasError('maxlength')"
                    >El Usuario no puede superar los 20 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('login').hasError('minlength')"
                    >El Usuario debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  formControlName="nombre_completo"
                  value=""
                  type="text"
                  id="anombreApellido"
                  class="form-control"
                  placeholder="Nombre y Apellido"
                  required
                  #nombreApellido
                  maxLength="100"
                  disabled
                />
                <label for="nombreApellido">Nombre y Apellido</label>
                <div
                  *ngIf="
                    formulario.get('nombre_completo').invalid &&
                    (formulario.get('nombre_completo').dirty ||
                      formulario.get('nombre_completo').touched)
                  "
                >
                  <mdb-error
                    *ngIf="
                      formulario.get('nombre_completo').hasError('required')
                    "
                    >El Nombre es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="
                      formulario.get('nombre_completo').hasError('maxlength')
                    "
                    >El Nombre no puede superar los 100 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="
                      formulario.get('nombre_completo').hasError('minlength')
                    "
                    >El Nombre debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  formControlName="mail"
                  value=""
                  type="email"
                  id="aemail"
                  class="form-control"
                  placeholder="Email"
                  [(ngModel)]="UsuarioObject.mail"
                  required
                  #email
                />
                <label for="email">Email</label>
                <div
                  *ngIf="
                    formulario.get('mail').invalid &&
                    (formulario.get('mail').dirty ||
                      formulario.get('mail').touched)
                  "
                >
                  <mdb-error *ngIf="formulario.get('mail').hasError('required')"
                    >El Correo es requerido.</mdb-error
                  >
                  <mdb-error *ngIf="formulario.get('mail').hasError('email')"
                    >El Correo no es valido.</mdb-error
                  >
                </div>
              </div>
            </div>

            <!-- Right -->
            <div class="col">
              <div class="md-form">
                <input
                  formControlName="password"
                  value=""
                  type="password"
                  id="apass"
                  class="form-control"
                  placeholder="Contraseña"
                  required
                  #pass
                  maxLength="15"
                />
                <label for="pass">Contraseña</label>
                <div
                  *ngIf="
                    formulario.get('password').invalid &&
                    (formulario.get('password').dirty ||
                      formulario.get('password').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('password').hasError('required')"
                    >La Contraseña es requerido.
                  </mdb-error>
                  <mdb-error
                    *ngIf="formulario.get('password').hasError('maxlength')"
                    >La Contraseña no puede superar los 15
                    caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('password').hasError('minlength')"
                    >La Contraseña tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  value=""
                  formControlName="confirmarpass"
                  type="password"
                  id="aconfirmarPass"
                  class="form-control"
                  placeholder="Confirmar contraseña"
                  required
                  #confirmarPass
                  maxLength="15"
                />
                <label for="confirmarPass">Confirmar contraseña</label>
                <div
                  *ngIf="
                    formulario.get('confirmarpass').invalid &&
                    (formulario.get('confirmarpass').dirty ||
                      formulario.get('confirmarpass').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('confirmarpass').hasError('required')"
                    >La Confirmacion de Contraseña es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="
                      formulario.get('confirmarpass').hasError('maxlength')
                    "
                    >La Confirmacion de Contraseña no puede superar los 15
                    caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="
                      formulario.get('confirmarpass').hasError('minlength')
                    "
                    >La Confirmacion de Contraseña debe tener como mínimo 5
                    caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('confirmarpass').hasError('mismatch')"
                    >La Contraseña no coincide.
                  </mdb-error>
                </div>
              </div>
              <div class="md-form">
                <mdb-select
                  formControlName="rol"
                  label="Rol"
                  [options]="optionsRol"
                  placeholder="Roles"
                ></mdb-select>
                <div
                  *ngIf="
                    formulario.get('rol').invalid &&
                    (formulario.get('rol').dirty ||
                      formulario.get('rol').touched)
                  "
                >
                  <mdb-error *ngIf="formulario.get('rol').hasError('required')"
                    >Por favor seleccione un Rol</mdb-error
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="sucursal"
                  label="Sucursales"
                  [options]="optionsSucursal"
                  placeholder="Sucursales"
                ></mdb-select>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <button
                type="button"
                mdbBtn
                color="info"
                [disabled]="
                  formulario.get('rut_usuario').hasError('ValidaFormatoRut')
                "
                (click)="agregarSucursal()"
                size="sm"
                mdbWavesEffect
              >
                Agregar
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Codigo</th>
                  <th scope="col">Sucursal</th>
                  <th scope="col">Fecha de asignación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngIf="
                    !usuarioSucursalList || usuarioSucursalList.length === 0
                  "
                >
                  <td colspan="7" style="text-align: center">
                    Debe agregar una Sucursal
                  </td>
                </tr>
                <tr *ngFor="let suc of usuarioSucursalList; let i = index">
                  <td>{{ suc.sucursal_codigo }}</td>
                  <td>{{ suc.nombre }}</td>
                  <td>{{ suc.fecha_asignacion | date: "dd/MM/yyyy" }}</td>
                  <td>
                    <button
                      mdbBtn
                      type="button"
                      size="sm"
                      color="primary"
                      mdbWavesEffect
                      class="btn-actions-sm"
                      (click)="eliminarSucursal(i)"
                    >
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="limpiarFormulario()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="submit"
            class="btn btn-secondary waves-light"
            mdbWavesEffect
            [disabled]="
              formulario.invalid ||
              !usuarioSucursalList ||
              usuarioSucursalList.length === 0
            "
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
